function p(e, s) {
  return s.some((t) => t.value === e);
}
function n(e) {
  return e.classList && (e.classList.contains("_dialog_overlay") || e.classList.contains("backdrop")) ? !0 : typeof e.hasAttribute == "function" && e.hasAttribute("data-skip");
}
function r(e) {
  return e.nodeName === "OPTION" || e.nodeName === "DATA";
}
function c(e, s) {
  return e.nodeType === Node.ELEMENT_NODE && !p(e, s);
}
function d(e) {
  var s;
  return e.nodeType === Node.TEXT_NODE && ((s = e.nodeValue) == null ? void 0 : s.trim()) !== "";
}
class S {
  constructor(s, ...t) {
    this.nodes = [], this.filledSlots = /* @__PURE__ */ new Set(), this.skipOptions = !1, this.updatingSlots = !1, this.needsSlotUpdate = !0, this.host = s, this.host.addController(this), this.slots = t, this.nodes = [], this.observer = new MutationObserver((l) => {
      this.handleMutations(l), this.handleSlotMutations(l);
    });
  }
  hostConnected() {
    this.updateNodes(), this.observer.observe(this.host, { childList: !0, subtree: !0 });
  }
  hostDisconnected() {
    this.observer.disconnect();
  }
  hostUpdated() {
    this.needsSlotUpdate && (this.needsSlotUpdate = !1, this.updateSlots());
  }
  // ********* UPDATE NODES *********
  updateNodes() {
    this.nodes = [], Array.from(this.host.childNodes).forEach((t) => {
      n(t) || r(t) && this.skipOptions || (!p(t, this.slots) || d(t)) && this.nodes.push(t);
    });
  }
  // ********* UPDATE SLOTS *********
  updateSlots() {
    if (this.updatingSlots) return;
    this.updatingSlots = !0;
    const s = /* @__PURE__ */ new Set();
    this.slots.forEach((t) => {
      if (!t.value) return;
      const l = t.value.getAttribute("name");
      Array.from(t.value.childNodes).some((o) => {
        var u, f;
        if (o.nodeType === Node.COMMENT_NODE) return !1;
        if (o.nodeType === Node.TEXT_NODE) return !!((u = o.textContent) != null && u.trim());
        if (o.nodeType === Node.ELEMENT_NODE) {
          if (n(o)) return !1;
          if ((f = o.textContent) != null && f.trim()) return !0;
        }
        return !1;
      }) && s.add(l);
      const a = this.nodes.flatMap(
        (o) => d(o) || o.getAttribute && o.getAttribute("slot") == l && !n(o) ? o : []
      ).filter(
        (o) => t.value && !t.value.contains(o) && !o.contains(t.value)
      );
      if (a.length > 0)
        if (typeof t.value.replaceChildren != "function") {
          for (; t.value.firstChild; )
            t.value.removeChild(t.value.firstChild);
          t.value.append(...a);
        } else
          t.value.replaceChildren(...a);
    }), (this.filledSlots.size !== s.size || ![...this.filledSlots].every((t) => s.has(t))) && (this.filledSlots = s, typeof this.host.updateSlots == "function" && this.host.updateSlots(this.filledSlots)), this.updatingSlots = !1;
  }
  // ********* HANDLE MUTATIONS *********
  handleMutations(s) {
    let t = !1;
    s.forEach((l) => {
      l.type !== "childList" || l.target !== this.host || (l.addedNodes.forEach((i) => {
        n(i) || r(i) && this.skipOptions || (c(i, this.slots) || d(i)) && (this.nodes.push(i), t = !0);
      }), l.removedNodes.forEach((i) => {
        n(i) || r(i) && this.skipOptions || (this.nodes = this.nodes.filter((h) => h !== i), t = !0);
      }));
    }), t && (this.needsSlotUpdate = !0, this.updateSlots());
  }
  handleSlotMutations(s) {
    let t = !1;
    s.forEach((l) => {
      const i = l.target.parentElement;
      if (i != null && i.hasAttribute("slot")) {
        const h = i.getAttribute("slot"), a = i.hasChildNodes();
        a && !this.filledSlots.has(h) ? (this.filledSlots.add(h), t = !0) : !a && this.filledSlots.has(h) && (this.filledSlots.delete(h), t = !0);
      }
    }), t && typeof this.host.updateSlots == "function" && this.host.updateSlots(this.filledSlots);
  }
}
export {
  S as P,
  r as i
};
